import { when, set } from 'cerebral/operators';
import { props } from 'cerebral/tags';

import submitAnswer from '../actions/submitAnswer';
import setEndNotification from '../actions/setEndNotification';
import setTips from '../actions/setTips';
import trackEvent from '../actions/trackEvent';
import trackFullCompletionEvent from '../actions/trackFullCompletionEvent';

export default [
    setEndNotification,
    when(props`isLast`),
    {
        true: [
            setTips,
            submitAnswer, {
                success: [],
                error: [],
            },
            set(props`eventAction`, 'part_completed'),
            set(props`eventProperties.event_label`, props`part`),
            trackEvent,
            trackFullCompletionEvent,
        ],
        false: [],
    },
];



// WEBPACK FOOTER //
// ./src/store/modules/app/signals/answerSet.js